import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RichTextEditorComponent } from '@Shared/components/rich-text-editor/rich-text-editor.component';

@Component({
  selector: 'shared-add-note-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    RichTextEditorComponent
  ],
  templateUrl: './shared-add-note-form.component.html',
  styleUrls: ['./shared-add-note-form.component.scss']
})
export default class SharedAddNoteFormComponent implements OnInit, OnDestroy {
  @Input() noteForm: UntypedFormGroup;
  @Input() newMessage: string = '';
  @Input() noteError = false;
  @Input() disabled: boolean = false;
  @Input() showVisibilityToggle: boolean = false;
  @Input() visibilityIconButtonClass: string = 'mat-mdc-note-icon-button';
  @Input() placeholder: string = 'Add Note';

  @Output() clearClicked = new EventEmitter<void>();
  @Output() saveClicked = new EventEmitter<string>();
  @Output() visibilityToggled = new EventEmitter<void>();
  @Output() messageChanged = new EventEmitter<string>();

  @ViewChild('templateDrivenEditor') templateDrivenEditor: RichTextEditorComponent;

  ngOnInit() {}

  ngOnDestroy() {}

  clearForm() {
    this.newMessage = '';
  }

  onClear() {
    this.clearClicked.emit();
  }

  onSave() {
    this.saveClicked.emit(this.newMessage);
  }

  onVisibilityToggle() {
    this.visibilityToggled.emit();
  }

  onMessageChange(value: string) {
    this.messageChanged.emit(value);
  }
}
